import React, { useState, useEffect } from 'react';
import Modal from '../common/Modal';

export default function RemovePlayersModal({ show, onClose, players = [], maxKeep = 2, onConfirm, hostUserId, hostSocketId, allowSpectators = false }) {
  const visible = typeof show !== 'undefined' ? show : false;
  const [selectedToRemove, setSelectedToRemove] = useState([]);

  useEffect(() => {
    if (!visible) setSelectedToRemove([]);
  }, [visible]);

  if (!visible) return null;

  const handleToggle = (id) => {
    // Prevent toggling the host
    if (!id) return;
    if (id === hostUserId || id === hostSocketId) return;
    setSelectedToRemove((prev) => {
      if (prev.includes(id)) return prev.filter((p) => p !== id);
      return [...prev, id];
    });
  };

  const currentCount = players.length;
  const neededRemovals = Math.max(0, currentCount - maxKeep);
  const canConfirm = selectedToRemove.length >= neededRemovals;
  const actionLabel = allowSpectators ? 'move to spectators' : 'remove';
  const actionButtonLabel = allowSpectators ? 'Move to Spectators' : 'Remove';

  return (
    <Modal show={visible} title={`${allowSpectators ? 'Move' : 'Remove'} ${neededRemovals} player${neededRemovals !== 1 ? 's' : ''}`} onClose={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-lg p-4">
        <p className="mb-2">The selected game supports up to {maxKeep} players, but there are currently {currentCount} players in the room. Please choose {neededRemovals} player{neededRemovals !== 1 ? 's' : ''} to {actionLabel}.</p>
        <div className="max-h-64 overflow-auto mb-4">
          {players.map((p) => {
            const pid = p.userId || p.socketId || p.id;
            const isHost = pid === hostUserId || pid === hostSocketId;
            return (
              <label key={pid} className="flex items-center gap-2 p-2 border-b last:border-b-0">
                <input type="checkbox" checked={selectedToRemove.includes(pid)} onChange={() => handleToggle(pid)} disabled={isHost} />
                <span className="ml-2">{p.username || p.name || 'Unknown'}{isHost ? ' (Host)' : ''}</span>
              </label>
            );
          })}
        </div>
        <div className="flex gap-2">
          <button className="flex-1 bg-gray-400 text-white p-2 rounded" onClick={onClose}>Cancel</button>
          <button className={`flex-1 text-white p-2 rounded ${allowSpectators ? 'bg-blue-600' : 'bg-red-600'}`} onClick={() => onConfirm(selectedToRemove)} disabled={!canConfirm}>{`${actionButtonLabel} ${selectedToRemove.length} player${selectedToRemove.length !== 1 ? 's' : ''}`}</button>
        </div>
      </div>
    </Modal>
  );
}
